/*
 * @Author: hfxie
 * @Date: 2023-09-12 10:23:53
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-07-23 15:11:02
 * @Description: 数据仓库
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters.js";

function createStore() {
  const store = new Vuex.Store({
    state: {
      uuid: "",
      themeColor: "#5582f3", // 主题色
      width: 1000, // 控件宽
      height: 800, // 控件高
      dataLoadingStatus: false, // 控件数据加载态
      initTimeStamp: "time-0", // 虚拟列表回顶key
      /* 接收数据 */
      data: {
        list: [  // 行数据
          // {}
        ],
        headers: [ // 表头配置
          // {},
        ],
        iconMap: { // 图标字典
          // "iconKey"： "url-XXX"
        },
        configMap: { // 配置字典
          treeName: "名称",
          treeWidth: 250,
          stayInPlace: false,// 初始化回顶·暂未使用
        },
        selectedArr: [ // 选中行id·暂未开放
          // "xxId"
        ],
      },
      /* 本地状态 */
      expandMap: {},
      isCheckBoxShow: false,
      isIconImageShow: false,
      rowHeight: 32,
      detailId: "", // 选中展示行Id
      minRowsNum: 30, // 虚拟列表最少裁剪展示行数
      langMap: { // 多语言字段集合
        topPlaceholder: "请输入搜索名称",
      },

    },
    mutations: mutations,
    actions: actions,
    modules: {},
    getters: getters,
  });
  return store;
}

export default createStore;

